<template>
  <div class="product-channel-root">
    <!-- 顶部标题栏 -->
    <div class="header-bar">
      <span class="header-title">产品渠道配置</span>
    </div>
    <div class="main-row">
      <!-- 左侧渠道分组菜单 可拖拽宽度 -->
      <div
          class="side-menu"
          :style="{width: leftWidth + 'px'}">
        <div class="search-bar-row">
          <a-input-search
              placeholder="分组名称"
              style="width: 60%;"
              v-model="searchGroupName"
              @search="onGroupSearch"/>
          <div class="search-bar-actions">
            <a-tooltip placement="top" title="刷新">
              <a-icon type="reload" class="search-bar-icon" @click="refreshGroupList"/>
            </a-tooltip>
            <a-tooltip placement="top" title="新增分组">
              <a-icon type="plus" class="search-bar-icon" @click="onAddGroup"/>
            </a-tooltip>
            <a-tooltip placement="top" title="修改分组">
              <a-icon type="edit" class="search-bar-icon"
                      @click="onEditGroup(groupList.find(item => item.id === selectedGroupId))"/>
            </a-tooltip>
            <a-tooltip placement="top" title="删除分组">
              <a-icon type="delete" class="search-bar-icon"
                      @click="onDeleteGroup(groupList.find(item => item.id === selectedGroupId))"/>
            </a-tooltip>
          </div>
        </div>
        <div class="menu-list">
          <div
              v-for="item in groupList"
              :key="item.id"
              :class="['menu-item', { active: item.id === selectedGroupId, disabled: item.status === 0 }]"
              @click="selectedGroupId = item.id">
            <div class="menu-item-row" :title="item.groupName">
              <div>
                <span class="menu-code">{{ item.groupName }}</span>
                <a-button
                    type="link"
                    size="small"
                    @click.stop="copyToClipboard(item.groupName)"
                    style="margin-left: 6px; padding: 0 4px; color: rgb(82, 196, 26)"
                    title="复制">
                  <a-icon type="copy" style="font-size: 12px;"/>
                </a-button>
              </div>
              <span class="menu-arrow"><a-icon type="right"/></span>
            </div>
            <div class="menu-item-info">
              <span
                  class="menu-location"
                  :title="'渠道数量: ' + (item.quantity || 0)+' 个'"
                  :style="{maxWidth: (leftWidth - 60) + 'px'}">
                渠道数量: <span style="color: #1890ff;font-size: 14px; font-weight: 600;">{{ item.quantity || 0 }}</span> 个
              </span>
              <span class="menu-status" :title="item.status"
                    :style="{color: getStatusColor(item.status)}">{{ getStatusText(item.status) }}</span>
            </div>
          </div>
        </div>
        <div class="menu-pagination">
          <a-pagination
              :current="groupPage"
              :pageSize="groupPageSize"
              :total="groupTotal"
              showSizeChanger
              :show-total="total => `总共 ${groupTotal} 个`"
              @change="onGroupPageChange"
              @showSizeChange="onGroupPageChange"
              size="small"/>
        </div>
      </div>
      <!-- 拖拽分割条 -->
      <div class="drag-bar" @mousedown="onDragStart"></div>
      <!-- 右侧内容 -->
      <div class="main-content">
        <div class="main-card">
          <!-- 顶部信息 -->
          <div class="main-info">
            <div class="main-info-title">
              {{ selectedGroup ? selectedGroup.groupName : '请选择渠道分组' }}
              <a-tooltip placement="top" title="刷新" v-if="selectedGroupId">
                <a-icon type="reload" class="refresh-icon" @click="refreshRightData"/>
              </a-tooltip>
            </div>
            <div class="main-info-desc">
              <span v-if="selectedGroup">
                 状态: <span :style="{color: getStatusColor(selectedGroup.status), fontWeight: '600'}">{{ getStatusText(selectedGroup.status) }}</span> |
                 渠道数量: <span style="color: #1890ff; font-size: 14px; font-weight: 600;">{{ selectedGroup.quantity || 0 }}</span> 个
               </span>
              <span v-else>选择左侧分组查看渠道详情</span>
            </div>
          </div>
          <!-- 渠道操作按钮 -->
          <div class="main-summary" v-if="selectedGroupId">
            <div>
              <a-button type="primary" icon="plus" @click="onAddChannel">
                新增渠道
              </a-button>
              <a-button icon="search" style="margin-left: 8px;" @click="showChannelSearch = !showChannelSearch">
                {{ showChannelSearch ? '隐藏搜索' : '显示搜索' }}
              </a-button>
            </div>
          </div>
          <!-- 渠道搜索区域 -->
          <div class="channel-search" v-if="showChannelSearch && selectedGroup">
            <a-form layout="inline">
              <a-form-item label="产品渠道">
                <a-input placeholder="请输入产品渠道" v-model="channelSearchParam.productCode"
                         style="width: 150px;"></a-input>
              </a-form-item>
              <a-form-item label="状态">
                <a-select placeholder="请选择状态" v-model="channelSearchParam.status" allowClear style="width: 120px;">
                  <a-select-option :value=true>启用</a-select-option>
                  <a-select-option :value=false>禁用</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="refreshChannelData">搜索</a-button>
                <a-button style="margin-left: 8px;" @click="resetChannelSearch">重置</a-button>
              </a-form-item>
            </a-form>
          </div>
          <!-- 表格滚动区 -->
          <div class="table-list">
            <div v-if="!selectedGroupId" class="empty-state">
              <a-empty description="请选择左侧渠道分组查看渠道列表"/>
            </div>
            <a-table
                v-else
                :columns="channelColumns"
                :dataSource="channelData"
                :pagination="false"
                rowKey="id"
                size="middle"
                bordered
                class="main-table"
                :loading="channelLoading"
                :scroll="{ x: 'max-content' }">
              <template slot="statusSlot" slot-scope="text">
                <a-tag :color="text === 1 ? 'green' : 'red'">
                  {{ text === 1 ? '启用' : '禁用' }}
                </a-tag>
              </template>
              <template slot="countrySlot" slot-scope="text, record">
                <div v-if="record.countryList && record.countryList.length > 0">
                  <a-tag v-for="(country, index) in record.countryList.slice(0, 2)" :index="index"
                         :key="country.countryCode" style="margin: 1px;">
                    <img :src="`https://flagcdn.com/24x18/${country.countryCode.toLowerCase()}.png`"
                         :alt="country.countryCode"
                         style="width: 16px; height: 12px; margin-right: 4px; vertical-align: middle;"/>
                    {{ country.countryNameCn }}
                  </a-tag>
                  <a-popover v-if="record.countryList.length > 2" placement="top" trigger="click">
                    <template slot="content">
                      <div style="max-width: 500px;">
                        <a-tag v-for="(country, index) in record.countryList" :index="index" :key="country.countryCode"
                               style="margin: 2px;">
                          <img :src="`https://flagcdn.com/24x18/${country.countryCode.toLowerCase()}.png`"
                               :alt="country.countryCode"
                               style="width: 16px; height: 12px; margin-right: 4px; vertical-align: middle;"/>
                          {{ country.countryNameCn }}
                        </a-tag>
                      </div>
                    </template>
                    <a-tag
                        style="margin: 1px; cursor: pointer; background-color: #1890ff; border-color: #1890ff; color: white;">
                      +{{ record.countryList.length - 2 }} 国家
                    </a-tag>
                  </a-popover>
                </div>
                <span v-else>-</span>
              </template>
              <template slot="channelAction" slot-scope="text, record">
                <a @click="onEditChannel(record)">编辑</a>
                <a-divider type="vertical"/>
                <a-popconfirm title="确定删除吗?" @confirm="() => onDeleteChannel(record)">
                  <a style="color: #ff4d4f;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>
          <!-- 右侧分页控件 -->
          <div class="table-pagination" v-if="selectedGroupId">
            <a-pagination
                :current="channelPage"
                :pageSize="channelPageSize"
                :total="channelTotal"
                showSizeChanger
                :show-total="total => `总共 ${channelTotal} 个`"
                @change="onChannelPageChange"
                @showSizeChange="onChannelPageChange"
                size="small"/>
          </div>
        </div>
      </div>
    </div>

    <!-- 渠道分组弹窗 -->
    <a-modal
        :title="groupModalTitle"
        :width="600"
        :visible="groupVisible"
        :confirmLoading="groupConfirmLoading"
        @ok="handleGroupOk"
        @cancel="handleGroupCancel"
        cancelText="取消">
      <a-spin :spinning="groupConfirmLoading">
        <a-form-model
            ref="groupForm"
            :model="groupModel"
            :rules="groupValidatorRules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol">
          <a-form-model-item label="分组名称" prop="groupName">
            <a-input v-model="groupModel.groupName" placeholder="请输入分组名称"></a-input>
          </a-form-model-item>
          <a-form-model-item label="状态" prop="status">
            <a-radio-group v-model="groupModel.status">
              <a-radio :value=true>启用</a-radio>
              <a-radio :value=false>禁用</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>

    <!-- 渠道弹窗 -->
    <a-modal
        :title="channelModalTitle"
        :width="800"
        :visible="channelVisible"
        :confirmLoading="channelConfirmLoading"
        @ok="handleChannelOk"
        @cancel="handleChannelCancel"
        cancelText="取消">
      <a-spin :spinning="channelConfirmLoading">
        <a-form-model
            ref="channelForm"
            :model="channelModel"
            :rules="channelValidatorRules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol">
          <a-form-model-item label="产品渠道" prop="productCode">
            <a-input v-model="channelModel.productCode" placeholder="请输入产品渠道"></a-input>
          </a-form-model-item>
          <a-form-model-item label="渠道别名" prop="productAlias">
            <a-input v-model="channelModel.productAlias" placeholder="请输入渠道别名"></a-input>
          </a-form-model-item>
          <a-form-model-item label="状态" prop="status">
            <a-radio-group v-model="channelModel.status">
              <a-radio :value="1">启用</a-radio>
              <a-radio :value="0">禁用</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="最小申报金额" prop="minDeclaredAmount">
            <a-input-number v-model="channelModel.minDeclaredAmount" placeholder="请输入最小申报金额" :min="0"
                            style="width: 100%;"></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="最大申报金额" prop="maxDeclaredAmount">
            <a-input-number v-model="channelModel.maxDeclaredAmount" placeholder="请输入最大申报金额" :min="0"
                            style="width: 100%;"></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="最小重量(KG)" prop="minWeight">
            <a-input-number v-model="channelModel.minWeight" placeholder="请输入最小重量" :min="0" :precision="2"
                            style="width: 100%;"></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="最大重量(KG)" prop="maxWeight">
            <a-input-number v-model="channelModel.maxWeight" placeholder="请输入最大重量" :min="0" :precision="2"
                            style="width: 100%;"></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="邮编分区" prop="deliveryDispatch">
            <a-select v-model="channelModel.deliveryDispatch" placeholder="请选择邮编分区">
              <a-select-option v-for="item in deliveryOptions" :key="item.id"
                               :value="item.groupName">
                {{ item.groupName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="单号规则" prop="numberRuleId">
            <a-select v-model="channelModel.numberRuleId" placeholder="请选择单号规则">
              <a-select-option v-for="item in numberRuleOptions" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="适用国家" prop="countryCode">
            <a-select
                v-model="channelModel.countryCode"
                mode="multiple"
                placeholder="请选择适用国家"
                show-search
                :maxTagCount="5"
                :filter-option="filterCountryOption"
                :maxTagPlaceholder="getMaxTagPlaceholder"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :virtual="true"
                :listHeight="400"
                :itemHeight="40"
                optionFilterProp="children"
                style="width: 100%;">
              <a-select-option v-for="item in countryOptions" :key="item.countryCodeD" :value="item.countryCodeD"
                               class="country-option">
                <div class="country-option-content">
                  <img
                      :src="`https://flagcdn.com/24x18/${item.countryCodeD.toLowerCase()}.png`"
                      :alt="item.countryCodeD"
                      class="country-flag"
                      @error="handleFlagError"/>
                  <span
                      :class="['country-name', { 'country-name-selected': channelModel.countryCode && channelModel.countryCode.includes(item.countryCodeD) }]">{{
                      item.countryNameCn
                    }}</span>
                </div>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import {
  productChannelPage,
  productChannelInsert,
  productChannelUpdate,
  productChannelDelete,
  channelGroupPage,
  channelGroupCreate,
  channelGroupUpdate,
  channelGroupDelete,
  numberRuleList,
  getAllCountry
} from '@/api/product'
import { postalCodeGroupList } from '@/api/postalCodeGroup'

export default {
  name: "ProductChannel",
  data() {
    return {
      // 左侧分组相关
      searchGroupName: '',
      selectedGroupId: null,
      groupList: [],
      groupPage: 1,
      groupPageSize: 10,
      groupTotal: 0,
      groupLoading: false,

      // 右侧渠道相关
      channelData: [],
      channelPage: 1,
      channelPageSize: 10,
      channelTotal: 0,
      channelLoading: false,
      showChannelSearch: false,
      channelSearchParam: {
        productCode: '',
        status: undefined
      },

      // 渠道列定义
      channelColumns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {title: '产品渠道', dataIndex: 'productCode', key: 'productCode', align: "center"},
        {title: '渠道别名', dataIndex: 'productAlias', key: 'productAlias', align: "center"},
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: "center",
          scopedSlots: {customRender: 'statusSlot'}
        },
        {title: '最小申报金额', dataIndex: 'minDeclaredAmount', key: 'minDeclaredAmount', width: 120, align: "center"},
        {title: '最大申报金额', dataIndex: 'maxDeclaredAmount', key: 'maxDeclaredAmount', width: 120, align: "center"},
        {title: '最小重量(KG)', dataIndex: 'minWeight', key: 'minWeight', width: 120, align: "center"},
        {title: '最大重量(KG)', dataIndex: 'maxWeight', key: 'maxWeight', width: 120, align: "center"},
        {title: '邮编分区', dataIndex: 'deliveryDispatch', key: 'deliveryDispatch', width: 120, align: "center"},
        {
          title: '单号规则',
          dataIndex: 'numberRuleName',
          key: 'numberRuleName',
          width: 120,
          align: "center",
          customRender: (text, record) => {
            // 如果有numberRuleName直接显示，否则根据numberRuleId查找对应名称
            if (text) {
              return text;
            }
            if (record.numberRuleId) {
              const numberRule = this.numberRuleOptions.find(item => item.id === record.numberRuleId);
              return numberRule ? numberRule.name : record.numberRuleId;
            }
            return '-';
          }
        },
        {
          title: '适用国家',
          dataIndex: 'countryCode',
          key: 'countryCode',
          width: 150,
          align: "center",
          scopedSlots: {customRender: 'countrySlot'}
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 120,
          scopedSlots: {customRender: 'channelAction'}
        }
      ],

      // 布局相关
      leftWidth: 350,
      dragging: false,
      startX: 0,
      startWidth: 350,

      // 分组弹窗相关
      groupVisible: false,
      groupConfirmLoading: false,
      groupModel: {},
      groupValidatorRules: {
        groupName: [
          {required: true, message: '请输入分组名称!', trigger: 'blur'},
          {min: 2, max: 50, message: '分组名称长度在 2 到 50 个字符', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '请选择状态!', trigger: 'change'}
        ]
      },

      // 渠道弹窗相关
      channelVisible: false,
      channelConfirmLoading: false,
      channelModel: {
        productCode: '',
        productAlias: '',
        status: 1,
        minDeclaredAmount: '',
        maxDeclaredAmount: '',
        minWeight: '',
        maxWeight: '',
        deliveryDispatch: null,
        numberRuleId: null,
        countryCode: []
      },
      channelValidatorRules: {
        productCode: [
          {required: true, message: '请输入产品渠道!', trigger: 'blur'}
        ],
        productAlias: [
          {required: true, message: '请输入渠道别名!', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '请选择状态!', trigger: 'change'}
        ],
        minDeclaredAmount: [
          {required: true, message: '请输入最小申报金额!', trigger: 'blur'}
        ],
        maxDeclaredAmount: [
          {required: true, message: '请输入最大申报金额!', trigger: 'blur'}
        ],
        minWeight: [
          {required: true, message: '请输入最小重量!', trigger: 'blur'}
        ],
        maxWeight: [
          {required: true, message: '请输入最大重量!', trigger: 'blur'}
        ],
        deliveryDispatch: [
          {required: true, message: '请选择邮编分区!', trigger: 'change'}
        ],
        numberRuleId: [
          {required: true, message: '请选择单号规则!', trigger: 'change'}
        ],
        countryCode: [
          {required: true, message: '请选择国家!', trigger: 'change'}
        ]
      },

      // 下拉选项
      deliveryOptions: [],
      numberRuleOptions: [],
      countryOptions: [],

      // 表单布局
      labelCol: {
        xs: {span: 24},
        sm: {span: 7}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 13}
      }
    }
  },
  computed: {
    selectedGroup() {
      return this.groupList.find(item => item.id === this.selectedGroupId);
    },
    groupModalTitle() {
      return this.groupModel.id ? '编辑渠道分组' : '新增渠道分组';
    },
    channelModalTitle() {
      return this.channelModel.id ? '编辑渠道' : '新增渠道';
    },
    displayedCountries() {
      return (this.channelModel.countryCode || []).slice(0, 5);
    },
    hiddenCountriesCount() {
      return Math.max(0, (this.channelModel.countryCode || []).length - 5);
    },
    hiddenCountriesText() {
      return (this.channelModel.countryCode || [])
          .slice(5)
          .map(code => this.getCountryDisplayName(code))
          .join(', ');
    }
  },
  watch: {
    selectedGroupId: {
      handler() {
        this.channelPage = 1;
        // 重置搜索参数
        this.channelSearchParam = {
          productCode: '',
          status: undefined
        };
        // 隐藏搜索区域
        this.showChannelSearch = false;
        this.refreshChannelData();
      }
    }
  },
  created() {
    this.loadGroupData();
    this.loadDeliveryOptions();
    this.loadNumberRuleOptions();
    this.loadCountryOptions();
  },

  methods: {
    getMaxTagPlaceholder() {
      // 2. 获取当前选中的国家代码（直接使用channelModel.countryCode更可靠）
      const selectedCountries = this.channelModel.countryCode || [];
      if (selectedCountries.length <= 5) {
        return '';
      }

      const slicedData = this.channelModel.countryCode.slice(5);
      // 获取隐藏的国家代码
      const hiddenCountries = slicedData.map(value => ({
        code: value,
        name: this.getCountryDisplayName(value)
      }));
      console.log(hiddenCountries)

      return (
          <a-popover
              placement="top"
              trigger="hover"
              content={
                <div style="max-width: 500px; display: flex; flex-wrap: wrap; gap: 4px;">
                  {hiddenCountries.map(country => (
                      <div key={country.code}
                           style="display: inline-flex; align-items: center; margin: 2px; padding: 2px 6px; background: #f5f5f5; border-radius: 4px; white-space: nowrap;">
                        <img
                            src={`https://flagcdn.com/24x18/${country.code.toLowerCase()}.png`}
                            alt={country.code}
                            style="width: 16px; height: 12px; margin-right: 4px; vertical-align: middle;"
                            onError={this.handleFlagError}
                        />
                        <span style="font-size: 12px;">{country.name}</span>
                      </div>
                  ))}
                </div>
              }
          >
            <a-tag style="cursor: pointer; background-color: #f0f0f0; border-color: #d9d9d9;">
              +{slicedData.length}国家
            </a-tag>
          </a-popover>
      );
    },

    // 复制到剪贴板
    copyToClipboard(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      document.body.appendChild(textarea)
      textarea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('已复制到剪贴板')
        } else {
          this.$message.error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败: ' + err)
      } finally {
        document.body.removeChild(textarea)
      }
    },

    // 状态相关
    getStatusText(status) {
      return status == 1 ? '启用' : '禁用';
    },
    getStatusColor(status) {
      return status == 1 ? '#52c41a' : '#ff4d4f';
    },

    // 加载渠道分组数据
    async loadGroupData() {
      this.groupLoading = true;
      try {
        const res = await channelGroupPage({
          current: this.groupPage,
          size: this.groupPageSize,
          groupName: this.searchGroupName
        });
        if (res.code == 200) {
          this.groupList = res.data.records || [];
          this.groupTotal = res.data.total || 0;
          // 自动选中第一条
          if (this.groupList.length > 0 && !this.selectedGroupId) {
            this.selectedGroupId = this.groupList[0].id;
          }
        } else {
          this.$message.error(res.message || '分组列表加载失败');
        }
      } catch (e) {
        this.$message.error('分组列表加载失败');
      } finally {
        this.groupLoading = false;
      }
    },

    // 加载渠道数据
    async refreshChannelData() {
      if (!this.selectedGroupId) {
        this.channelData = [];
        this.channelTotal = 0;
        return;
      }

      this.channelLoading = true;
      try {
        const params = {
          current: this.channelPage,
          size: this.channelPageSize,
          groupId: this.selectedGroupId,
          ...this.channelSearchParam
        };
        const res = await productChannelPage(params);
        if (res.code == 200) {
          this.channelData = res.data.records || [];
          this.channelTotal = res.data.total || 0;
        }
      } catch (e) {
        this.$message.error('渠道数据加载失败');
      } finally {
        this.channelLoading = false;
      }
    },

    // 加载下拉选项
    async loadDeliveryOptions() {
      try {
        const res = await postalCodeGroupList();
        console.log('邮编分区选项', res)
        if (res.code == 200) {
          this.deliveryOptions = res.data || [];
        }
      } catch (e) {
        console.error('邮编分区选项加载失败', e);
      }
    },

    async loadNumberRuleOptions() {
      try {
        const res = await numberRuleList({type: "bar_code_number"});
        if (res.code == 200) {
          this.numberRuleOptions = res.data || [];
        }
      } catch (e) {
        console.error('单号规则选项加载失败', e);
      }
    },

    async loadCountryOptions() {
      try {
        const res = await getAllCountry({});
        console.log('国家选项', res)
        if (res.code == 200) {
          this.countryOptions = res.data || [];
        }
      } catch (e) {
        console.error('国家选项加载失败', e);
      }
    },

    // 分组搜索
    onGroupSearch() {
      this.groupPage = 1;
      this.loadGroupData();
    },

    // 刷新分组列表
    refreshGroupList() {
      this.loadGroupData();
    },

    // 刷新右侧数据
    async refreshRightData() {
      if (!this.selectedGroup) {
        this.$message.warning('请先选择一个渠道分组');
        return;
      }
      this.$message.loading('正在刷新数据...', 0.5);
      await this.refreshChannelData();
    },

    // 分组分页
    onGroupPageChange(page, pageSize) {
      this.groupPage = page;
      this.groupPageSize = pageSize;
      this.loadGroupData();
    },

    // 渠道分页
    onChannelPageChange(page, pageSize) {
      this.channelPage = page;
      this.channelPageSize = pageSize;
      this.refreshChannelData();
    },

    // 重置渠道搜索
    resetChannelSearch() {
      this.channelSearchParam = {
        productCode: '',
        status: undefined
      };
      this.channelPage = 1;
      this.refreshChannelData();
    },

    // 分组操作
    onAddGroup() {
      this.groupModel = {
        groupName: '',
        status: 1
      };
      this.groupVisible = true;
    },

    onEditGroup(item) {
      if (!item) {
        this.$message.warning('请先选择要编辑的分组');
        return;
      }
      this.groupModel = {...item};

      console.log('分组数据:', this.groupModel)
      this.groupVisible = true;
    },

    onDeleteGroup(item) {
      if (!item) {
        this.$message.warning('请先选择要删除的分组');
        return;
      }
      this.$confirm({
        title: '确认删除',
        content: `您确定要删除分组"${item.groupName}"吗？`,
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          try {
            const res = await channelGroupDelete({id: item.id});
            if (res.success) {
              this.$message.success('删除成功');
              this.loadGroupData();
              if (this.selectedGroupId === item.id) {
                this.selectedGroupId = null;
                this.channelData = [];
              }
            } else {
              this.$message.error(res.message || '删除失败');
            }
          } catch (e) {
            this.$message.error('删除失败');
          }
        }
      });
    },

    handleGroupOk() {
      this.$refs.groupForm.validate(async valid => {
        if (valid) {
          this.groupConfirmLoading = true;
          try {
            const isEdit = !!this.groupModel.id;
            const apiCall = isEdit ?
                channelGroupUpdate(this.groupModel) :
                channelGroupCreate(this.groupModel);

            const res = await apiCall;
            if (res.code == 200) {
              this.$message.success(isEdit ? '更新成功' : '新增成功');
              this.groupVisible = false;
              this.loadGroupData();
            } else {
              this.$message.error(res.message || '操作失败');
            }
          } catch (e) {
            this.$message.error('操作失败');
          } finally {
            this.groupConfirmLoading = false;
          }
        }
      });
    },

    handleGroupCancel() {
      this.groupVisible = false;
      this.$refs.groupForm.resetFields();
    },

    // 渠道操作
    async onAddChannel() {
      if (!this.selectedGroupId) {
        this.$message.warning('请先选择渠道分组');
        return;
      }
      // 加载下拉选项数据
      await Promise.all([
        this.loadDeliveryOptions(),
        this.loadNumberRuleOptions(),
        this.loadCountryOptions()
      ]);

      this.channelModel = {
        productCode: '',
        productAlias: '',
        status: 1,
        minDeclaredAmount: '',
        maxDeclaredAmount: '',
        minWeight: '',
        maxWeight: '',
        deliveryDispatch: null,
        numberRuleId: null,
        countryCode: []
      };
      this.channelVisible = true;
    },

    async onEditChannel(record) {
      // 加载下拉选项数据
      await Promise.all([
        this.loadDeliveryOptions(),
        this.loadNumberRuleOptions(),
        this.loadCountryOptions()
      ]);

      // 处理国家代码数据回显
      let countryCodeArray = [];
      if (record.countryList && record.countryList.length > 0) {
        // 如果有countryList，从中提取countryCode
        countryCodeArray = record.countryList.map(country => country.countryCode);
      } else if (record.countryCode) {
        // 如果countryCode是字符串，按逗号分割
        if (typeof record.countryCode === 'string') {
          countryCodeArray = record.countryCode.split(',').filter(code => code.trim());
        } else if (Array.isArray(record.countryCode)) {
          countryCodeArray = record.countryCode;
        }
      }
      console.log('渠道数据record.numberRuleId:', record.numberRuleId)
      this.channelModel = {
        ...record,
        countryCode: countryCodeArray,
        numberRuleId: record.numberRuleId
      };
      this.channelVisible = true;
    },

    onDeleteChannel(record) {
      this.$confirm({
        title: '确认删除',
        content: `确定要删除渠道"${record.productCode}"吗？`,
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          try {
            const res = await productChannelDelete({id: record.id});
            if (res.success) {
              this.$message.success('删除成功');
              this.refreshChannelData();
            } else {
              this.$message.error(res.message || '删除失败');
            }
          } catch (e) {
            this.$message.error('删除失败');
          }
        }
      });
    },

    handleChannelOk() {
      this.$refs.channelForm.validate(async valid => {
        if (valid) {
          this.channelConfirmLoading = true;
          try {
            const isEdit = !!this.channelModel.id;
            const params = {
              ...this.channelModel,
              groupId: this.selectedGroupId
            };

            const apiCall = isEdit ?
                productChannelUpdate(params) :
                productChannelInsert(params);

            const res = await apiCall;
            if (res.code == 200) {
              this.$message.success(isEdit ? '更新成功' : '新增成功');
              this.channelVisible = false;
              this.refreshChannelData();
            } else {
              this.$message.error(res.message || '操作失败');
            }
          } catch (e) {
            this.$message.error('操作失败');
          } finally {
            this.channelConfirmLoading = false;
          }
        }
      });
    },

    handleChannelCancel() {
      this.channelVisible = false;
      this.$refs.channelForm.resetFields();
    },

    // 拖拽相关
    onDragStart(e) {
      this.dragging = true;
      this.startX = e.clientX;
      this.startWidth = this.leftWidth;
      document.body.style.userSelect = 'none';
      document.addEventListener('mousemove', this.onDragging);
      document.addEventListener('mouseup', this.onDragEnd);
      e.preventDefault();
      e.stopPropagation();
    },

    onDragging(e) {
      if (!this.dragging) return;
      const delta = e.clientX - this.startX;
      let newWidth = this.startWidth + delta;
      if (newWidth < 250) newWidth = 250;
      if (newWidth > 600) newWidth = 600;
      this.leftWidth = newWidth;
      e.preventDefault();
      e.stopPropagation();
    },

    onDragEnd(e) {
      this.dragging = false;
      document.body.style.userSelect = '';
      document.removeEventListener('mousemove', this.onDragging);
      document.removeEventListener('mouseup', this.onDragEnd);
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 0);
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
    },

    // 国家选择搜索过滤
    filterCountryOption(input, option) {
      const country = this.countryOptions.find(item => item.countryCodeD === option.key);
      if (!country) return false;
      const searchText = input.toLowerCase();
      return country.countryNameCn.toLowerCase().includes(searchText) ||
          country.countryNameEn.toLowerCase().includes(searchText) ||
          country.countryCodeD.toLowerCase().includes(searchText);
    },

    // 根据国家代码获取国家名称
    getCountryName(countryCode) {
      const country = this.countryOptions.find(item => item.countryCodeD === countryCode);
      return country ? country.countryNameCn : countryCode;
    },

    // 根据国家代码数组获取国家名称数组
    getCountryNames(countryCodes) {
      if (!Array.isArray(countryCodes)) return [];
      return countryCodes.map(code => this.getCountryName(code));
    },

    // 获取国家显示名称（用于标签显示）
    getCountryDisplayName(countryCode) {
      const country = this.countryOptions.find(item => item.countryCodeD === countryCode);
      return country ? country.countryNameCn : countryCode;
    },


    // 清空国家选择
    clearAllCountries(e) {
      if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
        e.stopPropagation();
      }
      this.channelModel.countryCode = [];
    },

    // 自定义max-tag-placeholder
    maxTagPlaceholder(omittedValues) {
      console.log('omittedValues', omittedValues);

      return `+${omittedValues.length}个国家`;
    },

    // 处理国旗图片加载错误
    handleFlagError(event) {
      // 当国旗图片加载失败时，隐藏图片元素
      event.target.style.display = 'none';
    }
  },
  mounted() {
    window.addEventListener('mouseup', this.onDragEnd);
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.onDragEnd);
  }
}
</script>

<style scoped>
.product-channel-root {
  background: #f5f7fa;
  height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
}

.header-bar {
  height: 48px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
}

.main-row {
  display: flex;
  height: calc(100vh - 48px);
}

.side-menu {
  background: #fff;
  border-right: 1px solid #e8e8e8;
  padding: 0;
  height: 100%;
  min-width: 250px;
  max-width: 600px;
  box-sizing: border-box;
  transition: width 0.1s;
  position: relative;
  display: flex;
  flex-direction: column;
}

.drag-bar {
  width: 5px;
  cursor: ew-resize;
  background: #f0f0f0;
  height: 100%;
  z-index: 10;
  transition: background 0.2s;
}

.drag-bar:hover {
  background: #d0d0d0;
}

.menu-list {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.menu-pagination {
  flex-shrink: 0;
  padding: 8px 8px 20px 0;
  background: #fff;
  text-align: right;
  z-index: 2;
}

.menu-item {
  padding: 8px 16px;
  cursor: pointer;
  border-left: 3px solid transparent;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.2s, border-color 0.2s;
}

.menu-item.active {
  background: #e6f7ff;
  border-left: 3px solid #1890ff;
}

.menu-item-row {
  display: flex;
  align-items: center;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  justify-content: space-between;
}

.menu-code {
  max-width: 200px;
  color: #1890ff;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.menu-arrow {
  margin-left: 8px;
  flex-shrink: 0;
  color: #bfbfbf;
}

.menu-item.active .menu-arrow {
  color: #1890ff;
}

.menu-item-info {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #888;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
  justify-content: space-between;
}

.menu-location {
  font-weight: 500;
  font-size: 13px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.menu-status {
  margin-left: 8px;
  color: #666;
  font-weight: 600;
  font-size: 13px;
  max-width: 60px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  flex-shrink: 0;
  text-align: right;
}

.main-content {
  background: #f5f7fa;
  min-height: 0;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.main-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px #f0f1f2;
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  padding: 24px;
}

.main-info {
  margin-bottom: 15px;
}

.main-info-title {
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon {
  font-size: 16px;
  color: #666;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s;
}

.refresh-icon:hover {
  color: #1890ff;
  transform: rotate(180deg);
}

.main-info-desc {
  color: #888;
  margin-top: 2px;
}

.main-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;
  flex-shrink: 0;
}

.channel-search {
  background: #fafafa;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
}

.main-table {
  background: #fff;
  flex: 1;
  min-width: 0;
}

.search-bar-row {
  display: flex;
  align-items: center;
  padding: 8px 0 8px 0;
  border-bottom: 1px solid #e8e8e8;
  margin: 0 12px 8px 12px;
  justify-content: space-between;
}

.search-bar-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-bar-icon {
  font-size: 18px;
  color: #333;
  cursor: pointer;
  transition: color 0.2s;
}

.search-bar-icon:hover {
  color: #1890ff;
}

.table-list {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.table-pagination {
  flex-shrink: 0;
  padding: 8px 0 0 0;
  background: #fff;
  text-align: right;
  z-index: 2;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

.menu-item.disabled {
  position: relative;
  opacity: 0.7;
}

.menu-item.disabled::after {
  content: "已禁用";
  position: absolute;
  top: 50%;
  left: 70%;
  transform: translate(-50%, -50%) rotate(-20deg);
  font-size: 18px;
  color: #ff4d4f;
  font-weight: 600;
  pointer-events: none;
  z-index: 1;
  opacity: 0.8;
}

/* 国家选择下拉选项样式 */
.country-option .country-option-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 0;
  min-height: 40px;
}

.country-option .country-flag {
  width: 20px;
  height: 15px;
  margin-right: 12px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 2px;
  vertical-align: text-top !important
}

.country-option .country-name {
  flex: 1;
  line-height: 1.5;
  font-size: 14px;
}

/* 确保下拉选项有足够的内边距 */
.ant-select-dropdown .ant-select-item-option {
  padding: 6px 12px !important;
  min-height: 40px !important;
  display: flex !important;
  align-items: center !important;
}

.ant-select-dropdown .ant-select-item-option .country-option-content {
  width: 100%;
  position: relative;
}

/* 优化下拉框滚动条样式 */
.ant-select-dropdown .ant-select-item-option-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 虚拟滚动优化 */
.ant-select-dropdown {
  max-height: 400px !important;
}

.ant-select-dropdown .rc-virtual-list {
  max-height: 400px !important;
}

/* Selected country tags styling */
.country-tag {
  display: flex;
  align-items: center;
  padding: 2px 8px;
  margin: 2px;
  border-radius: 4px;
  background-color: #f0f0f0;
  border: 1px solid #d9d9d9;
}

.country-tag .country-tag-flag {
  width: 16px;
  height: 12px;
  margin-right: 2px;
  border-radius: 2px;
  object-fit: cover;
}

.country-tag .country-tag-name {
  font-size: 12px;
  color: #333;
}

/* 已选中国家名称样式 */
.country-name-selected {
  color: #2857f3 !important;
  font-weight: 600 !important;
  margin-left: 2px;
}


</style>
